<template>
    <div>
        <!-- <nav-bar title="协议"></nav-bar> -->
        <div class="Padding">
            <h3>绍兴银行股份有限公司手机银行支付协议</h3>
            <div class="white-bg">
                <p class="content"><span class="bold">甲方：</span>个人客户</p>
                <p class="content"><span class="bold">乙方：</span>绍兴银行股份有限公司</p>
                <p class="content">根据国家相关法律法规的规定，为维护双方利益，规范双方行为，甲乙双方本着自愿、平等、互利的原则，就个人客户（以下简称“甲方”）使用绍兴银行股份有限公司（以下简称“乙方”）手机银行支付服务（简称“手机支付”）签订如下协议：</p>
                <p class="content"><span class="bold">第一条  </span>乙方提供的手机支付服务是指甲方签约成为乙方的手机银行客户后，开通手机支付功能，在手机商城等电子商务网站上购买商品或服务，然后通过手机的无线网络向乙方发出支付指令，实现货币的支付与资金转移。</p>
                <p class="content"><span class="bold">第二条  </span>甲方申请使用乙方的手机支付功能必须首先成功申请成为乙方手机银行的客户（大众版手机银行客户不能申请手机支付功能）。甲方通过乙方手机支付所进行的交易，乙方均视为甲方亲自办理，甲方不得要求变更或撤销已经提交的支付指令。</p>
                <p class="content"><span class="bold">第三条  </span>甲方在签订本协议后指定用于手机支付的合法账户为手机银行有转账权限功能的账户。</p>
                <p class="content"><span class="bold">第三条  </span>甲方在签订本协议后指定用于手机支付的合法账户为手机银行有转账权限功能的账户。</p>
                <p class="content"><span class="bold">第五条  </span>如因甲方指定账户已销户或账户状态不正常（挂失、冻结）、余额不足等原因，导致乙方无法履行协议的，乙方不承担任何责任。</p>
                <p class="content"><span class="bold">第六条  </span>甲方与除甲乙双方之外的任何第三方机构（包括但不限于移动通信公司、手机的售后服务方、第三方支付平台、甲方所购买商品或服务的销售方、商品配送方等）之间的交易纠纷与乙方无关。乙方不受理甲方对其他任何第三方的投诉。</p>
                <p class="content"><span class="bold">第七条  </span>乙方可以自主根据业务发展需要增加、删除或变更合作的手机支付商户。</p>
                <p class="content"><span class="bold">第八条  </span>甲方通过在乙方手机银行同意本协议并经过短信口令认证后开通手机支付功能；甲方如需终止使用乙方提供的手机支付服务，可通过点击相关页面的取消功能撤销支付服务。</p>
                <p class="content"><span class="bold">第九条  </span>本协议作为甲乙双方已经签署的《绍兴银行股份有限公司电子银行个人客户服务协议》、《绍兴银行股份有限公司电子银行章程》及其他既有协议和约定的补充而非替代文件，与其具有同样的法律效力。甲方在使用乙方提供的服务时应遵守电子银行章程、业务规则和已签署的所有相关协议，以及其他相关的业务规定。</p>
                <p class="content"><span class="bold">第十条  </span>甲方发现自身未按规定操作，或由于自身其他原因造成手机支付指令未执行、未适当执行、延迟执行的，应及时通过拨打服务热线或到营业网点通知乙方。乙方应积极调查并告知甲方调查结果。</p>
                <p class="content"><span class="bold">第十一条  </span>因不可抗力或其他非乙方原因（设备故障、通讯线路故障、手机故障及断电、停电等）造成的乙方没有正确执行甲方提交的手机支付指令或业务中断，乙方不承担任何责任。</p>
                <p class="content"><span class="bold">第十二条  </span>甲乙双方在履行本协议的过程中，如发生争议应协商解决，协商不成的，按照双方已经签署的《绍兴银行股份有限公司电子银行个人客户服务协议》、《绍兴银行股份有限公司电子银行章程》中约定的方式解决。</p>
                <p class="content"><span class="bold">第十三条  </span>本协议的成立、生效、履行和解释，均适用中华人民共和国法律；法律无明文规定的，可适用通行的金融惯例。</p>
                <p class="content"><span class="bold">第十四条  </span>本协议自甲方在手机银行同意开通手机支付功能之时起生效，自撤销本服务之时起终止。所有时间均以乙方手机银行系统记录的时间为准。协议终止并不意味着终止前所发生的未完成交易指令的撤销，也不能消除因终止前的交易所带来的任何法律后果。</p>
                <p class="content"><span class="bold">第十五条  </span>本协议解释和修订权归属乙方。</p>
            </div>
            <ui-button class="btn-blue" @click="agree">我已确认并同意</ui-button>
        </div>
    </div>
</template>

<script>
import NavBar from '@/components/NavBar';
export default {
    components:{
        NavBar
    },
    data(){
        return{}
    },
    methods: {
        agree(){
            this.$store.state.routerFlag = false;
            this.$store.state.agreeFlag = true;
            this.$router.replace("/sign")
        }
    },
}
</script>

<style scoped>
    .Padding{
        padding: 0.5rem 0 0 0
    }
    .white-bg{
        width:96%;
        margin: 0 auto;
        background: #fff
    }
    p{
        text-align: left;
        font-size: 24px;
        line-height: 38px;
    }
    .content{
        text-indent: 2em;
    }
    .title{
        text-align: center;
    }
    .bold{
        font-weight: bold;
    }
    .fontsize24{
        font-size: 24px;
    }
    .fontsize30{
        font-size: 30px;
    }
    .redcolor{
        color: red;
    }
    .underLine{
        text-decoration: underline;
    }
</style>



// WEBPACK FOOTER //
// src/views/Agreement/agreement.vue